import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearCredentials, setCredentials, updateImage } from "../../authSlice";
import { LockIcon } from "../../assets/svg";
import toast from "react-hot-toast";

function Profile() {
  const { token } = useSelector((state) => state.auth);
  const { username, image } = useSelector((state) => state.auth);
  const [passwordModal, setPasswordModal] = useState(false);
  const [changePassword, setChangePassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [imgUploading, setImgUploading] = useState(false);
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
  });
  const [defaultProfileImg, setDefaultProfileImg] = useState(
    "https://placehold.co/600x400?text=Admin"
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [profileImg, setProfileImg] = useState(
    image ? image : defaultProfileImg
  );
  const fileInputRef = useRef(null);

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    setImgUploading(true);
    setDefaultProfileImg("https://placehold.co/600x400?text=Loading");
    if (file) {
      const formData = new FormData();
      formData.append("image", file);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/uploadImage`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.status === 401) {
          dispatch(clearCredentials());
          return
        }

        const data = await response.json();
        if (response.ok) {
          setProfileImg(data.imageUrl);
          dispatch(updateImage(data.imageUrl));
          toast.success(data.message, {
            style: {
              border: "1px solid #021F7E",
              padding: "16px",
              color: "#0573E3",
            },
            iconTheme: {
              primary: "#021F7E",
              secondary: "#fff",
            },
            duration: 6000,
          });
        } else {
          toast.error(data.error, {
            style: {
              border: "1px solid #FE0000",
              padding: "16px",
              color: "#FE0000",
            },
            iconTheme: {
              primary: "#FE0000",
              secondary: "#fff",
            },
            duration: 6000,
          });
          throw new Error("Failed to upload image");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        setDefaultProfileImg("https://placehold.co/600x400?text=Admin");
        setImgUploading(false);
      }
    }
  };

  const signOut = () => {
    dispatch(setCredentials({ token: null, username: null }));
    toast.success("user logged out", {
      style: {
        border: "1px solid #021F7E",
        padding: "16px",
        color: "#0573E3",
      },
      iconTheme: {
        primary: "#021F7E",
        secondary: "#fff",
      },
      duration: 6000,
    });
    navigate("/login");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const modalClose = () => {
    setPasswordModal(false);
    setChangePassword("");
    setFormData({
      oldPassword: "",
      newPassword: "",
    });
  };

  const validateForm = () => {
    let formErrors = {};

    if (!formData.oldPassword)
      formErrors.oldPassword = "Old Password is required";
    if (!formData.newPassword) {
      formErrors.newPassword = "New Password is required";
    } else if (formData.newPassword.length < 8) {
      formErrors.newPassword = "Password must be at least 8 characters long";
    } else if (!/(?=.*[A-Za-z])(?=.*\d)/.test(formData.newPassword)) {
      formErrors.newPassword = "Password must contain both letters and numbers";
    }
    if (formData.newPassword !== changePassword)
      formErrors.changePassword = "password does not match";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/changePassword`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.status === 401) {
        dispatch(clearCredentials());
        return
      }

      if (response.ok) {
        const data = await response.json();
        const newAccessToken = response.headers.get("Authorization");
        if (newAccessToken) {
          dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
        }
        if (data.status === 201 || data.status === 200) {
          setChangePassword("");
          setFormData({
            oldPassword: "",
            newPassword: "",
          });
          toast.success("password changed successfully", {
            style: {
              border: "1px solid #021F7E",
              padding: "16px",
              color: "#0573E3",
            },
            iconTheme: {
              primary: "#021F7E",
              secondary: "#fff",
            },
            duration: 6000,
          });
        } else {
          console.error("Error:", data.message);
        }
      } else {
        const data = await response.json();
        setErrors({ oldPassword: data.error });
        console.error("Failed to change password: ", data.error);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="whiteBgDiv dashboardTablePadding">
        <div className="mainHeading">System Administrator</div>
        <div className="profileBoxDiv">
          {!imgUploading ? (
            <div className="profileImgBox" onClick={handleBoxClick}>
              <img src={profileImg} className="img-fluid" alt="Profile-Img" />
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
          ) : (
            <div className="profileImgBox">
              <img
                src={defaultProfileImg}
                className="img-fluid"
                alt="Profile-Img"
              />
            </div>
          )}
          <div className="profileConent">
            <div
              className="mainHeading"
              style={{ textTransform: "capitalize" }}
            >
              {username}
            </div>
            <div className="adminPost">System Administrator</div>
            <div className="profileBtnFlex d-md-flex d-none">
              <button
                className="colorBtn"
                onClick={() => setPasswordModal(true)}
              >
                Change Password{" "}
              </button>
              <button className="grayBtn" onClick={signOut}>
                Sign Out
              </button>
            </div>
          </div>
        </div>
        <div
          className="d-flex justify-content-between d-md-none w-100 gap-2 flex-wrap"
          style={{ marginTop: "36px" }}
        >
          <button className="colorBtn" onClick={() => setPasswordModal(true)}>
            Change Password{" "}
          </button>
          <button className="grayBtn" onClick={signOut}>
            Sign Out
          </button>
        </div>
      </div>

      {passwordModal && (
        <>
          <div className="modalBackdrop">
            <div className="passwordModal">
              <div className="colorHeading">Change Password!</div>
              <p>Enter Old Password to update</p>
              <div className="customLogin" style={{ marginTop: "40px" }}>
                <LockIcon />
                <input
                  name="oldPassword"
                  type="password"
                  placeholder="Enter Old Password"
                  value={formData.oldPassword}
                  onChange={handleInputChange}
                />
              </div>
              {errors.oldPassword && (
                <span className="errorClass">{errors.oldPassword}</span>
              )}
              <div className="customLogin" style={{ marginTop: "10px" }}>
                <LockIcon />
                <input
                  name="newPassword"
                  type="password"
                  placeholder="Enter New Password"
                  value={formData.newPassword}
                  onChange={handleInputChange}
                />
              </div>
              {errors.newPassword && (
                <span className="errorClass">{errors.newPassword}</span>
              )}
              <div className="customLogin" style={{ marginTop: "10px" }}>
                <LockIcon />
                <input
                  type="password"
                  placeholder="Re-Enter New Password"
                  value={changePassword}
                  onChange={(e) => setChangePassword(e.target.value)}
                />
              </div>
              {errors.changePassword && (
                <span className="errorClass">{errors.changePassword}</span>
              )}
              <div className="modalActions">
                {loading ? (
                  <button className="grayBtn">Loading...</button>
                ) : (
                  <button className="colorBtn" onClick={handleSubmit}>
                    Submit
                  </button>
                )}
                <button className="grayBtn" onClick={modalClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Profile;
